/**
 * Extracted from sections/ns-faq.liquid (inline <script> at line 219).
 * Config bridge: window.__nsFaqSections, keyed by section id. The inline block
 * only needed Liquid for the section id, so the id is handed over as data
 * and the logic now runs from a cacheable, deferred asset instead of being
 * parsed and compiled during the HTML parse (INP work on the PDP).
 * Boots once per section id so multiple instances each initialise.
 */

(function () {
  var cfg = window.__nsFaqSections = window.__nsFaqSections || {};
  function boot(nsSectionId, nsSettings) {
      // Use an IIFE (Immediately Invoked Function Expression) to keep variables scoped
      (function() {
        // Get the section element by its ID
        const section = document.getElementById(`shopify-section-${nsSectionId}`);

        // Check if the section exists and has the button control
        const showControl = section ? section.querySelector('.faq-show-control') : null;
        const showButton = showControl ? showControl.querySelector('.js-faq-show-button') : null; // Target the button via the custom class

        if (showButton) {
          showButton.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent default link behavior (though button doesn't have one)

            // Find all hidden FAQ items within this section
            const hiddenItems = section.querySelectorAll('.faq-item__hide');

            // Remove the 'faq-item__hide' class from each hidden item
            hiddenItems.forEach(function(item) {
              item.classList.remove('faq-item__hide');
            });

            // Hide the button's container after revealing the items
            showControl.style.display = 'none';
          });
        }
      })(); // Execute the function immediately
  
  }
  Object.keys(cfg).forEach(function (id) {
    var s = cfg[id];
    if (!s || s.__booted) return;
    s.__booted = true;
    boot(id, s);
  });
})();
